// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__2oppY","div":"ProgressBar_div__2nblz","belt":"ProgressBar_belt__OY3-e","p":"ProgressBar_p__1zsZP"};